import { CARD_ERROR_TYPE } from '@linqpal/models/src/dictionaries'

export const errorHandling = (t, setError, err, setCardFlowCurrent) => {
  if (err.response?.data?.type === CARD_ERROR_TYPE.INVALID_CARD) {
    setError({
      msg1: t('AddCard.invalid-card'),
      msg2: t('AddCard.invalid-card-msg'),
      type: CARD_ERROR_TYPE.INVALID_CARD,
      action: null,
    })
  } else if (err.response?.data?.type === CARD_ERROR_TYPE.ADDRESS_MISMATCH) {
    setError({
      msg1: t('AddCard.invalid-address'),
      msg2: t('AddCard.invalid-address-msg'),
      type: CARD_ERROR_TYPE.ADDRESS_MISMATCH,
      action: () => {
        setCardFlowCurrent('AddressDetails')
        setError({
          msg1: '',
          msg2: '',
          type: '',
          action: null,
        })
      },
    })
  } else if (err.response?.data?.type === CARD_ERROR_TYPE.CVV_ERROR) {
    setError({
      msg1: t('AddCard.invalid-security-code'),
      msg2: t('AddCard.invalid-security-code-msg'),
      type: CARD_ERROR_TYPE.CVV_ERROR,
      action: null,
    })
  } else {
    setError({
      msg1: t('AddCard.network-error'),
      msg2: t('AddCard.network-error-msg'),
      type: CARD_ERROR_TYPE.NETWORK_ERROR,
      action: null,
    })
  }
}
